export function formatRelativeSeniority(relativeSeniority,totalOfCategoryEmployees) {
  const employeeStatistics = (sessionStorage.getItem('lng') === 'fr'
    ? require('./../../../../labels/labels.french.json')
    : require('./../../../../labels/labels.json')).employeeStatistics;
  if (relativeSeniority == 0 || relativeSeniority == null) {
    return employeeStatistics.RELATIVE_SENIORITY_NOT_APPLICABLE;
  }
  const percentageWithTowFractionDigitsFormat =  Math.round(relativeSeniority/totalOfCategoryEmployees * 100).toFixed(2) + "%";
  return relativeSeniority + "/" + totalOfCategoryEmployees + " - " + percentageWithTowFractionDigitsFormat;
}

